import { shallow } from 'zustand/shallow';
import { selectVisibleEdgeIds, useMindmapStore } from '../../store';
import { EdgeWrapper } from './EdgeWrapper';
import { MarkerDefinitions } from './MarkerDefinitions';

/** All edges in one SVG below the nodes (D-008). */
export const EdgeLayer = () => {
  const ids = useMindmapStore(selectVisibleEdgeIds, shallow);
  return (
    <svg className="cm-edges">
      <MarkerDefinitions />
      <g>
        {ids.map((id) => (
          <EdgeWrapper key={id} id={id} />
        ))}
      </g>
    </svg>
  );
};
